import React from 'react';
import style from './index.module.scss';
import QuickActions from '../QuickActions';
import Nav from '../Nav';
import logo from '@/assets/logo.svg';

/** 顶部Header组件 */
const Header = (props): JSX.Element => {
  return (
    <div className={style.header}>
      <div className={style.brand}>
        <img src={logo} className={style.logo} />
        <div className={style.sologon}>店铺运营专家</div>
      </div>
      <div className={style.navs}>
        <Nav {...props} />
      </div>
      <QuickActions />
    </div>
  );
};

export default Header;
